import React , { useState } from 'react';
import { NavLink } from 'react-router-dom';
import DefaultLayout from '../../layouts/default';
import Overview from './components/overview';
import Stats from './components/stats';
import OperationalChecks from './components/OperationalChecks';
import UpComming from './components/UpComming';
import ComplianceRecords from './components/ComplianceRecords';
import ComplianceTrend from './components/ComplianceTrend';
import { getLocalTodayString } from '../../components/CreationDate';

function CheckPage() {

  const [selectedDate, setSelectedDate] = useState(getLocalTodayString());

  return (
    <DefaultLayout>
      <Overview selectedDate={selectedDate} setSelectedDate={setSelectedDate} />
      <Stats selectedDate={selectedDate} />
      <div className="grid grid-cols-1 xl:grid-cols-12 gap-4 mt-6">
            <div className="col-span-9">
              <OperationalChecks selectedDate={selectedDate} setSelectedDate={setSelectedDate} />
              <ComplianceTrend />
            </div>
            <div className="col-span-3">
              <UpComming />
              <ComplianceRecords />
            </div>
      </div>

    </DefaultLayout>
  );
}

export default CheckPage;
